import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as HostingResourcesAction from '../actions/hosting-resources.action';
import {LoadHostingResourcesByWebsite} from '../actions/hosting-resources.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {HostingService} from "../../websites/website/hosting/hosting.service";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../reducers";

@Injectable()
export class HostingResourcesEffect {

  loadHostingResources$ = createEffect(() => this._actions$.pipe(
    ofType(HostingResourcesAction.LOAD_HOSTING_RESOURCES),
    mergeMap((action: any) => {
      return this._hostingService.getHostingResources(action.payload)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new HostingResourcesAction.LoadHostingResourcesSuccess({
                entities: response.data
              });
            }
            return new HostingResourcesAction.LoadHostingResourcesFail(response.message);
          })
        );
    })
  ));

  /*@Effect() loadUserSuccess$ = this._actions$.ofType(userActions.LOAD_USER_SUCCESS)
    .pipe(
      filter((loadUserSuccess: LoadUserSuccess) => !!loadUserSuccess.payload),
      switchMap((response: any) => {
        return this._store.select(fromStore.getWebsitesLoaded)
          .pipe(
            filter((response: any) => response),
            switchMap(() => this._store.select(fromStore.getHostedWebsites)),
            filter((response: any) => !!(response.length)),
            map(() => response)
          );
      }),
      map((loadUserSuccess: LoadUserSuccess) => {
        if (loadUserSuccess.payload.agreement && loadUserSuccess.payload.agreement.plan.services && loadUserSuccess.payload.agreement.plan.services.hosting) {
          return new HostingResourcesAction.LoadHostingResources();
        }
        return new HostingResourcesAction.LoadHostingResourcesFail("There is no hosting services");
      })
    );*/


  /*@Effect() updateWebsiteSubData$ = this._actions$.ofType(UPDATE_WEBSITE_SUB_DATA)
    .pipe(
      filter((action: UpdateWebsiteSubData) => !!action.payload.domain_hash),
      map((action: UpdateWebsiteSubData) => {
        return new HostingResourcesAction.LoadHostingResourcesByWebsite(action.payload.id);
      })
    );*/
  loadHostingResourcesByWebsite$ = createEffect(() => this._actions$.pipe(
    ofType(HostingResourcesAction.LOAD_HOSTING_RESOURCES_BY_WEBSITE),
    mergeMap((action: LoadHostingResourcesByWebsite) => {
      return this._hostingService.getHostingResourcesByWebsite(action.payload)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new HostingResourcesAction.LoadHostingResourcesByWebsiteSuccess({
                websiteId: action.payload,
                entities: response.data
              });
            }
            return new HostingResourcesAction.LoadHostingResourcesFail(response.message);
          })
        );
    })
  ));

  constructor(
    private _store: Store<DbStoreState>,
    private _actions$: Actions,
    private _hostingService: HostingService
  ) {
  }

}
